import React from 'react';

import Search from './search';
import { StyledContainer } from './styles';

const SearchForm = ({ autocomplete, updateQueryParam = true, placeholder }) => {
  return (
    <StyledContainer>
      <Search
        autocomplete={autocomplete}
        updateQueryParam={updateQueryParam}
        placeholder={placeholder}
      />
    </StyledContainer>
  );
};

export default SearchForm;
